import { DEFAULT_USER_ROLE } from '@common/constants/request.constants'
import { LocalStorageKey } from '@common/enums/global.enums'
import { Token, User } from '@common/types/request.types'

/**
 * Local storage utils
 */
export abstract class LocalStorageUtils {
	static getToken() {
		const localStorageAccessToken = localStorage.getItem(LocalStorageKey.ACCESS_TOKEN)
		const localStorageTokenExpiresAt = localStorage.getItem(LocalStorageKey.TOKEN_EXPIRES_AT)

		if (localStorageAccessToken && localStorageTokenExpiresAt) {
			if (Date.parse(localStorageTokenExpiresAt) < Date.now()) {
				return null
			}

			return {
				token: localStorageAccessToken,
				exp: Date.parse(localStorageTokenExpiresAt) - Date.now()
			} as Token
		}

		return null
	}

	static getUser(): User {
		return { role: localStorage.getItem(LocalStorageKey.ROLE) ?? DEFAULT_USER_ROLE }
	}

	static updateToken(newToken: Token | null) {
		if (newToken) {
			const expires = new Date(Date.now() + newToken.exp)
			localStorage.setItem(LocalStorageKey.ACCESS_TOKEN, newToken.token)
			localStorage.setItem(LocalStorageKey.TOKEN_EXPIRES_AT, expires.toString())
		} else {
			localStorage.removeItem(LocalStorageKey.ACCESS_TOKEN)
			localStorage.removeItem(LocalStorageKey.TOKEN_EXPIRES_AT)
		}
	}
}
